var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" This displays the previously captured photo (back to step 3 if needing additional photos (front/back/selfie)) "),_c('router-link',{attrs:{"to":"VerifyCompleted"}},[_vm._v("Next")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }